// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleListHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function () {
  var React = require('react');
  var SearchBox = require('./Izenda.SearchBox');
  var connect = require('share/enhancers/Izenda.Connect');

  var AuthorizationValidator = require('share/components/hoc/Izenda.AuthorizationValidator');
  var AuthorizationConstants = require('logic/data/Izenda.AuthorizationConstants');

  var AddUser = AuthorizationValidator()(function (props) {
    var localization = props.localization;
    return (
      <a
        className="overflow-text izenda-AddTenantLink"
        onClick={props.onClick }
        title={localization.getText('USER_SETUP_LABEL_ADD_USER')}>
        <span className="icon-plus" />
        {localization.getText('USER_SETUP_LABEL_ADD_USER')}
      </a>
    );
  });

  /**
   * Role List Header
   * @param {object} props The component's props that must have 'store' property
   */
  var UserSetupHeader = function (props) {
    var store = props.store;
    var onClickAddUser = function () {
      props.validation.reset();
      store.addUser();
    };
    return (
      <div className="header-panel">
        <AddUser
          localization = {props.localization}
          onClick={onClickAddUser}
          keys={[AuthorizationConstants.PERMISSION_KEY.UserSetupActionsCreate]}
          integrationHidden={true} />
        <div className="search-box">
          <SearchBox searchUser={props.searchUser} store={props.store} />
        </div>
        <hr />
      </div>
    );
  };

  UserSetupHeader.propTypes = {
    store: React.PropTypes.object.isRequired
  };

  module.exports = connect()(UserSetupHeader);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/UserSetup/MiddlePanel/Izenda.UserSetupHeader.jsx